<template>
  <div :class="classes">
    <div
      :class="`${baseClass}__progress`"
      :style="{ width: currentValue + '%' }"
    ></div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { UIKitRound, UIKitSize } from './types'

export type ProgressBarColor = 'primary' | 'secondary'

interface ProgressBarProps {
  value: number
  color?: ProgressBarColor
  size?: UIKitSize
  round?: UIKitRound
  isStriped?: boolean
  isAnimated?: boolean
}

const props = withDefaults(defineProps<ProgressBarProps>(), {
  value: 0,
  color: 'primary',
  size: 'md',
  round: 'circle',
})

const baseClass = 'progress-bar'

const currentValue = computed(() => {
  if (props.value < 0) return 0
  if (props.value > 100) return 100
  return props.value
})

const classes = computed(() => {
  const classes = [baseClass]
  if (props.color) {
    classes.push(`${baseClass}--color-${props.color}`)
  }
  if (props.size) {
    classes.push(`${baseClass}--size-${props.size}`)
  }
  if (props.round) {
    classes.push(`${baseClass}--round-${props.round}`)
  }
  if (props.isStriped) {
    classes.push(`${baseClass}--striped`)
  }
  if (props.isAnimated) {
    classes.push(`${baseClass}--animated`)
  }
  return classes
})
</script>
